import { Component, effect, input, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-avatar',
    templateUrl: './avatar.component.html',
    styleUrls: ['./avatar.component.scss'],
    imports: [TranslateModule],
})
export class AvatarComponent {
    readonly avatarSrc = input.required<string | undefined>();
    readonly isEditEnable = input<boolean>(false);

    readonly _avatarSrc = signal<string>('');

    constructor() {
        effect(() => {
            if (this.avatarSrc()) {
                this._avatarSrc.set(this.avatarSrc()!);
            } else {
                this._avatarSrc.set('assets/svgs-optimized-painted/avatar.svg');
            }
        });
    }

    onImageError() {
        this._avatarSrc.set('assets/svgs-optimized-painted/avatar.svg');
    }
}
